<template>
    <mounting-portal mount-to="#portalvue-i-report-component">
        <div class="flex pb-6 justify-start ">
            <div class="flex items-center" dir="rtl">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class=" w-12 ml-4"
                    viewBox="0 0 197 197"
                >
                    <g fill="none" fill-rule="evenodd">
                        <circle cx="98.5" cy="98.5" r="98.5" fill="#E53E3E" />
                        <g fill="#FFF" transform="translate(81 34)">
                            <ellipse cx="17" cy="17.318" rx="17" ry="17.318" />
                            <path
                                d="M17 46.182c9.273 0 16.812 7.475 16.997 16.768l.003.41v46.523C34 119.336 26.389 127 17 127s-17-7.664-17-17.117V63.299c0-9.453 7.611-17.117 17-17.117Z"
                            />
                        </g>
                    </g>
                </svg>
                <ul class=" flex items-center font-waheed  text-20px">
                    <li>
                        <button
                            @click="latest()"
                            class="px-6 py-2 ml-4  text-blue-800 rounded-full text-center"
                            :class="{
                                'bg-white': sort === 'published_at',
                                ' bg-transparent': sort !== 'published_at'
                            }"
                        >
                            އެންމެފަސް
                        </button>
                    </li>
                    <li>
                        <button
                            @click="popular()"
                            class="px-6 py-2 ml-4  text-blue-800  rounded-full text-center"
                            :class="{
                                'bg-white': sort === 'likes',
                                ' bg-transparent': sort !== 'likes'
                            }"
                        >
                            މަގުބޫލު
                        </button>
                    </li>
                </ul>
            </div>
        </div>
        <div class="space-y-8">
            <i-report-card
                v-for="(article, articleIndex) in articles"
                :key="articleIndex"
                :article="article"
            ></i-report-card>
        </div>

        <div class="flex justify-center mt-30px" v-if="page !== meta.last_page">
            <img
                src="https://cdn.mihaaru.com/assets/mhr/icons/icon-listing-more.svg"
                alt="icon load more"
                class="cursor-pointer"
                @click="loadMore()"
            />
        </div>
    </mounting-portal>
</template>
<script>
import IReportCard from "../../components/Election/IReportCard.vue";
export default {
    props: ["article"],
    components: {
        IReportCard
    },
    data() {
        return {
            articles: [],
            cursor: null,
            isLoading: true,
            page: 1,
            sort: "published_at",
            meta: {
                last_page: 0
            },
            titleCSS: "focus:outline-none latest cursor-pointer"
        };
    },
    mounted() {
        console.log("mounted");
        this.loadArticles(this.page);
    },
    methods: {
        popular() {
            this.page = 1;
            this.sort = "likes";
            this.loadArticles(this.page);
        },
        latest() {
            this.page = 1;
            this.sort = "published_at";
            this.loadArticles(this.page);
        },
        loadMore() {
            this.page++;
            this.loadArticles(this.page);
        },
        loadArticles(page) {
            this.isLoading = true;

            if (1 === page) {
                this.articles = [];
                this.cursor = null;
            }

            let uri = "home/i-reporter?page=" + page;

            if (this.sort === "likes") {
                uri += "&sort=-total_likes";
            }

            axios
                .get(uri)
                .then(resp => {
                    const response = resp.data;
                    this.meta = response.meta;
                    if (response.data.length > 0) {
                        this.articles.push(...response.data);
                        this.cursor = response.cursor;
                    }

                    this.isLoading = false;
                })
                .catch(e => {
                    console.error("LatestPopularWeeklyComponent.vue");
                    console.error(e);
                })
                .then(resp => {
                    this.isLoading = false;
                });
        }
    }
};
</script>
